import * as React from "react";
import ReactDOM = require("react-dom");
import axios from "axios";
import SignIn from "../components/SignIn";
import { APIUrls, Configs } from "../environments/ConfigDetails";
import qs = require("qs");

export const checkAccessTokenIsExpired = (): boolean => {
  let result = false;
  try {
    let settings = Office.context.roamingSettings;
    let accessTokenObj = settings.get("accessTokenObj");
    if (typeof accessTokenObj !== "undefined") {
      let expiredIn = accessTokenObj.expires_in;
      let dateObtained = accessTokenObj.date_obtained;
      let currentDate = new Date();
      let diff = Math.abs(currentDate.getTime() - dateObtained.getTime());
      let secondsDiff = Math.ceil(diff / 1000);
      if (secondsDiff <= expiredIn) {
        result = false;
      } else {
        result = true;
      }
    } else {
      result = true;
    }
  } catch (error) {
    console.warn('Access Token is expired...');
    result = true;
  }
  return result;
};
//refresh token
export const refreshAccessToken = (): any => {
  let accessTokenObj;
  try {
    let settings = Office.context.roamingSettings;
    let accessTokenObj = settings.get("accessTokenObj");
    let workspaceUrlPrefix = settings.get("WorkspaceURLPrefix")
    let workspaceUrltld = settings.get("WorkspaceURLtld")

    if (!workspaceUrlPrefix || !workspaceUrltld) {
      ReactDOM.render(<SignIn />, document.getElementById("container"));
      return;
    }

    axios({
      method: "post",
      url: APIUrls.urlForAccessToken(workspaceUrlPrefix, workspaceUrltld), // TODO: Figure out if this is even used anymore...
      data: qs.stringify({
        grant_type: Configs.refreshGrantType,
        refresh_token: accessTokenObj.refresh_token,
        redirect_uri: Configs.redirectUri,
        client_id: Configs.clientId
      }),
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8"
      }
    })
      .then(response => {
        let result = response.data;
        if (response.status === 200) {
          accessTokenObj = {
            access_token: result.access_token,
            expires_in: result.expires_in,
            refresh_token: result.refresh_token,
            scope: result.scope,
            token_type: result.token_type,
            date_obtained: new Date()
          };
          //save access token in roaming settings
          settings.set("accessTokenObj", accessTokenObj);
          settings.saveAsync(function(asyncResult) {
            if (asyncResult.status == Office.AsyncResultStatus.Failed) {
              console.error("Outlook failed to save the accessTokenObj...");
            } else {
              console.info("Access Token has been saved...");
            }
          });
          //return accessTokenObj;
        } else {
          accessTokenObj = null;
        }
      })
      .catch(() => {
        console.warn('Refreshing with refresh token has failed...');
        accessTokenObj = null;
        return accessTokenObj;
      });
    while (!(typeof accessTokenObj === "undefined")) {
      return accessTokenObj;
    }
  } catch (ex) {
    accessTokenObj = null;
    return accessTokenObj;
  }
};
